import React, { MouseEventHandler, useContext } from 'react'
import { IProyectos } from '../../../data/data.model'
import FiltersContext from '../../../../Context/FiltersContext'
import { Tooltip } from '@mui/material'

interface HexagonProps {
  project?: IProyectos
  size: number // Tamaño del hexágono (radio del círculo circunscrito)
  fill?: string // Color de relleno opcional
}

export const ProjectHexagon = ({
  project,
  size,
  fill = 'none',
}: HexagonProps) => {
  const { setProjectSelected } = useContext(FiltersContext)

  // Número de lados del hexágono
  const sides = 6
  // Ángulo en radianes entre cada vértice del hexágono
  const angle = (2 * Math.PI) / sides

  // Función para generar los puntos del hexágono
  const points = Array.from({ length: sides }, (_, i) => {
    const x = size * Math.cos(angle * i)
    const y = size * Math.sin(angle * i)
    return `${x},${y}`
  }).join(' ')

  const handleProjectClick = () => {
    setProjectSelected(project)
  }

  return (
    <Tooltip title={project?.nombre_proyecto} arrow>
      <div
        style={{
          padding: 2,
          maxHeight: size * 2,
          alignSelf: 'flex-start',
          cursor: 'pointer',
        }}
        onClick={project ? handleProjectClick : () => {}}
      >
        <svg
          viewBox={`${-size} ${-size} ${2 * size} ${2 * size}`}
          width={size * 2}
          height={size * 2}
        >
          <polygon points={points} fill={fill} />
        </svg>
      </div>
    </Tooltip>
  )
}
